
/// The interactive version of the payment transactions report: every Adyen
/// terminal line the venue registered, and per session the diff against the
/// registered platform rows - with the ability to OPERATE ( refund, re-check
/// the payout ), which the report cannot do. Selecting a row opens its
/// session's per-transaction reconcile view.
class PaymentTransactionsViewController extends BaseTableViewController
{
    static newInstance() : PaymentTransactionsViewController
    {
        let vc = new PaymentTransactionsViewController( "payment-transactions-view" );
        vc.initWithResource( "layout/paymenttransactions/PaymentTransactionsView.html" );
        return vc;
    }

    private columnFilterController:ColumnFilterController = null;

    private dateFilterTextField:ColumnFilterTextField = null;
    private referenceFilterTextField:ColumnFilterTextField = null;
    private amountFilterTextField:ColumnFilterTextField = null;

    viewDidLoad(): void {
        super.viewDidLoad();

        this.columnFilterController = new ColumnFilterController();
        this.columnFilterController.initWithDelegate(this);

        this.dateFilterTextField = MUIOutlet(this, "date-tf", "ColumnFilterTextField");
        this.dateFilterTextField.filterController = this.columnFilterController;
        this.dateFilterTextField.setOnFilterChange(ColumnFilterTextFieldType.Date, "date", null, null);

        this.referenceFilterTextField = MUIOutlet(this, "reference-tf", "ColumnFilterTextField");
        this.referenceFilterTextField.filterController = this.columnFilterController;
        this.referenceFilterTextField.setOnFilterChange(ColumnFilterTextFieldType.String, "transactionReference", null, null);

        this.amountFilterTextField = MUIOutlet(this, "amount-tf", "ColumnFilterTextField");
        this.amountFilterTextField.filterController = this.columnFilterController;
        this.amountFilterTextField.setOnFilterChange(ColumnFilterTextFieldType.Currency, "amount", null, null);

        this.tableView = MUIOutlet( this, "table-view", "UITableView" );
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath( indexPath ) as AdyenDevicePaymentTransaction;

        let cell = tableView.dequeueReusableCellWithIdentifier( "PaymentTransactionCell" ) as PaymentTransactionCell;
        cell.item = item;

        return cell;
    }

    didSelectCellAtIndexPath(tableView,indexPath:MIOIndexPath){
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as AdyenDevicePaymentTransaction;
        this.selectedItem = item;

        let session = item.cashDeskLine?.session;
        if (session == null) return;

        let vc = PaymentSessionTransactionsViewController.newInstance();
        vc.setSession( session.identifier, session.serverSessionName );
        AppHelper.sharedInstance().presentViewController( vc, true );
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [ MIOSortDescriptor.sortDescriptorWithKey( "date", false ) ];

        let predicateFormat = "deletedAt = null AND cashDeskLine != null";

        let filterPredicateFormat = this.columnFilterController.filterPredicateFormat();
        if (filterPredicateFormat != null){
            predicateFormat += " AND (" + filterPredicateFormat + ")";
        }

        let fetchRequest = DBHelper.listFetchRequestWithEntityName( "AdyenDevicePaymentTransaction", sortDescriptors, predicateFormat );
        fetchRequest.relationshipKeyPathsForPrefetching = [ "cashDeskLine.session" ];

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null );
        fetchedResultsController.delegate = this;

        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    filterPredicateDidChange(controller:ColumnFilterController){
        this._fetchedResultsController = null;
        this.tableView.reloadData();
    }

}

class PaymentTransactionCell extends UITableViewCell
{
    private dateLabel:MUILabel = null;
    private sessionLabel:MUILabel = null;
    private cardLabel:MUILabel = null;
    private referenceLabel:MUILabel = null;
    private amountLabel:MUILabel = null;

    awakeFromHTML(): void {
        this.dateLabel = MUIOutlet( this, "date-lbl", "MUILabel" );
        this.sessionLabel = MUIOutlet( this, "session-lbl", "MUILabel" );
        this.cardLabel = MUIOutlet( this, "card-lbl", "MUILabel" );
        this.referenceLabel = MUIOutlet( this, "reference-lbl", "MUILabel" );
        this.amountLabel = MUIOutlet( this, "amount-lbl", "MUILabel" );
    }

    set item( item: AdyenDevicePaymentTransaction ) {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        this.dateLabel.text = ad.dateTimeFormatter.stringFromDate( item.date );
        this.sessionLabel.text = item.cashDeskLine?.session?.serverSessionName;
        this.cardLabel.text = item.payMethodSubtype;
        this.referenceLabel.text = item.transactionReference;
        this.amountLabel.text = ad.currencyFormatter.stringFromNumber( item.amount );
    }
}
